export const getMediaType = (setIsMobile) => {
    if (window.innerWidth < 768 || document.documentElement.clientWidth < 768) {
        setIsMobile(true)
    } else {
        setIsMobile(false)
    }
}
